// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* spacing so editor never collides with buttons */
.faq-editor-wrap {
  margin-top: 16px;
  margin-bottom: 12px;   /* <-- ensures space before the button row */
}

.faq-editor-label {
  font-size: 14px;
  font-weight: 500;
  display: block;
  margin-bottom: 4px;
}

/* Make Quill root behave as column layout; size the container (not the root) */
.faq-editor {
  display: flex;
  flex-direction: column;
}

/* Toolbar styling can stay default */
.faq-editor .ql-toolbar.ql-snow {
  border-radius: 6px 6px 0 0;
}

/* Size the editable container and let it scroll instead of overflowing into buttons */
.faq-editor .ql-container.ql-snow {
  border-top: 0;
  border-radius: 0 0 6px 6px;
  min-height: 200px;      /* visible area height */
  max-height: 320px;      /* prevent huge growth; adjust if you want */
  overflow-y: auto;       /* <-- key: keeps content inside the editor */
}

/* Make the inner editor match your chat bubble look */
.faq-editor .ql-editor {
  font-size: 16px;
  line-height: 1.5;
  background: #fff;
  color: #333;
  padding: 7px;
  border-radius: 8px;
}

/* Paragraph spacing like chat */
.faq-editor .ql-editor p {
  margin: 0 0 .9em;
}

/* Lists like chat */
.faq-editor .ql-editor ul,
.faq-editor .ql-editor ol {
  margin: .9em 0;
  padding-left: 1.25em;
}
.faq-editor .ql-editor li {
  margin: .25em 0;
}

/* Links like chat */
.faq-editor .ql-editor a {
  color: #5616ea;
  text-decoration: underline;
  font-weight: 500;
}

/* Remove visual blank line when list follows a paragraph */
.faq-editor .ql-editor p + ul,
.faq-editor .ql-editor p + ol {
  margin-top: 0;
}

/* First/last-child tweaks */
.faq-editor .ql-editor > :first-child {
  margin-top: 0;
  padding-top: 0;
}
.faq-editor .ql-editor > :last-child {
  margin-bottom: 0;
  padding-top: 0;
}

.faq-editor-wrap {
  margin-top: 16px;
  margin-bottom: 12px;
  position: relative;
}

.faq-editor-label {
  font-size: 14px;
  font-weight: 500;
  display: block;
  margin-bottom: 4px;
}

/* Make Quill root behave as column layout; size the container (not the root) */
.faq-editor {
  display: flex;
  flex-direction: column;
}

.faq-editor .ql-container.ql-snow {
  border-top: 0;
  border-radius: 0 0 6px 6px;
  min-height: 200px;
  max-height: 320px;
  overflow-y: auto;   /* prevents overlap with buttons */
}

/* Chat-look styles (from earlier) */
.faq-editor .ql-editor {
  font-size: 16px;
  line-height: 1.5;
  background: #fff;
  color: #333;
  padding: 7px;
  border-radius: 8px;
}
.faq-editor .ql-editor p { margin: 0 0 .9em; }
.faq-editor .ql-editor ul,
.faq-editor .ql-editor ol { margin: .9em 0; padding-left: 1.25em; }
.faq-editor .ql-editor li { margin: .25em 0; }
.faq-editor .ql-editor a { color: #5616ea; text-decoration: underline; font-weight: 500; }
.faq-editor .ql-editor p + ul,
.faq-editor .ql-editor p + ol { margin-top: 0; }
.faq-editor .ql-editor > :first-child { margin-top: 0; padding-top: 0; }
.faq-editor .ql-editor > :last-child { margin-bottom: 0; padding-top: 0; }

/* Char counter */
.faq-char-counter {
  text-align: right;
  font-size: 12px;
  margin-top: 4px;
  color: #6b7280;
}
.faq-char-counter.limit { color: #d32f2f; }

.faq-editor-error {
  color: #d32f2f;
  font-size: 12px;
  margin-top: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AddFaqFromHistoryModal.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,mBAAmB,IAAI,4CAA4C;AACrE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,0BAA0B;AAC5B;;AAEA,sFAAsF;AACtF;EACE,aAAa;EACb,0BAA0B;EAC1B,iBAAiB,OAAO,wBAAwB;EAChD,iBAAiB,OAAO,4CAA4C;EACpE,gBAAgB,QAAQ,6CAA6C;AACvE;;AAEA,sDAAsD;AACtD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;;EAEE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;;EAEE,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB,IAAI,kCAAkC;AACxD;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA,2BAA2B,gBAAgB,EAAE;AAC7C;4BAC4B,cAAc,EAAE,oBAAoB,EAAE;AAClE,4BAA4B,eAAe,EAAE;AAC7C,2BAA2B,cAAc,EAAE,0BAA0B,EAAE,gBAAgB,EAAE;AACzF;gCACgC,aAAa,EAAE;AAC/C,wCAAwC,aAAa,EAAE,cAAc,EAAE;AACvE,uCAAuC,gBAAgB,EAAE,cAAc,EAAE;;AAEzE,iBAAiB;AACjB;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA,0BAA0B,cAAc,EAAE;;AAE1C;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* spacing so editor never collides with buttons */\r\n.faq-editor-wrap {\r\n  margin-top: 16px;\r\n  margin-bottom: 12px;   /* <-- ensures space before the button row */\r\n}\r\n\r\n.faq-editor-label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  display: block;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n/* Make Quill root behave as column layout; size the container (not the root) */\r\n.faq-editor {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* Toolbar styling can stay default */\r\n.faq-editor .ql-toolbar.ql-snow {\r\n  border-radius: 6px 6px 0 0;\r\n}\r\n\r\n/* Size the editable container and let it scroll instead of overflowing into buttons */\r\n.faq-editor .ql-container.ql-snow {\r\n  border-top: 0;\r\n  border-radius: 0 0 6px 6px;\r\n  min-height: 200px;      /* visible area height */\r\n  max-height: 320px;      /* prevent huge growth; adjust if you want */\r\n  overflow-y: auto;       /* <-- key: keeps content inside the editor */\r\n}\r\n\r\n/* Make the inner editor match your chat bubble look */\r\n.faq-editor .ql-editor {\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  background: #fff;\r\n  color: #333;\r\n  padding: 7px;\r\n  border-radius: 8px;\r\n}\r\n\r\n/* Paragraph spacing like chat */\r\n.faq-editor .ql-editor p {\r\n  margin: 0 0 .9em;\r\n}\r\n\r\n/* Lists like chat */\r\n.faq-editor .ql-editor ul,\r\n.faq-editor .ql-editor ol {\r\n  margin: .9em 0;\r\n  padding-left: 1.25em;\r\n}\r\n.faq-editor .ql-editor li {\r\n  margin: .25em 0;\r\n}\r\n\r\n/* Links like chat */\r\n.faq-editor .ql-editor a {\r\n  color: #5616ea;\r\n  text-decoration: underline;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Remove visual blank line when list follows a paragraph */\r\n.faq-editor .ql-editor p + ul,\r\n.faq-editor .ql-editor p + ol {\r\n  margin-top: 0;\r\n}\r\n\r\n/* First/last-child tweaks */\r\n.faq-editor .ql-editor > :first-child {\r\n  margin-top: 0;\r\n  padding-top: 0;\r\n}\r\n.faq-editor .ql-editor > :last-child {\r\n  margin-bottom: 0;\r\n  padding-top: 0;\r\n}\r\n\r\n.faq-editor-wrap {\r\n  margin-top: 16px;\r\n  margin-bottom: 12px;\r\n  position: relative;\r\n}\r\n\r\n.faq-editor-label {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  display: block;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n/* Make Quill root behave as column layout; size the container (not the root) */\r\n.faq-editor {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.faq-editor .ql-container.ql-snow {\r\n  border-top: 0;\r\n  border-radius: 0 0 6px 6px;\r\n  min-height: 200px;\r\n  max-height: 320px;\r\n  overflow-y: auto;   /* prevents overlap with buttons */\r\n}\r\n\r\n/* Chat-look styles (from earlier) */\r\n.faq-editor .ql-editor {\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  background: #fff;\r\n  color: #333;\r\n  padding: 7px;\r\n  border-radius: 8px;\r\n}\r\n.faq-editor .ql-editor p { margin: 0 0 .9em; }\r\n.faq-editor .ql-editor ul,\r\n.faq-editor .ql-editor ol { margin: .9em 0; padding-left: 1.25em; }\r\n.faq-editor .ql-editor li { margin: .25em 0; }\r\n.faq-editor .ql-editor a { color: #5616ea; text-decoration: underline; font-weight: 500; }\r\n.faq-editor .ql-editor p + ul,\r\n.faq-editor .ql-editor p + ol { margin-top: 0; }\r\n.faq-editor .ql-editor > :first-child { margin-top: 0; padding-top: 0; }\r\n.faq-editor .ql-editor > :last-child { margin-bottom: 0; padding-top: 0; }\r\n\r\n/* Char counter */\r\n.faq-char-counter {\r\n  text-align: right;\r\n  font-size: 12px;\r\n  margin-top: 4px;\r\n  color: #6b7280;\r\n}\r\n.faq-char-counter.limit { color: #d32f2f; }\r\n\r\n.faq-editor-error {\r\n  color: #d32f2f;\r\n  font-size: 12px;\r\n  margin-top: 2px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
